


const reducer = (state = {}) => state;

export default reducer;
